import { CalendarConfig } from '@wbk/calendar';

CalendarConfig.init({
  api: {
    cmsBase: process.env.VITE_CMS_BASE_URL!,
  },
  map: {
    apiKey: process.env.VITE_PUBLIC_GOOGLE_MAP_KEY!,
    mapId: process.env.VITE_PUBLIC_GOOGLE_MAP_ID!,
    defaultCenter: { lat: 24.7136, lng: 46.6753 },
    defaultZoom: 13,
    bounds: {
      north: 25.4,
      south: 24.4,
      east: 47.2,
      west: 46.1,
    },
  },
});
